<template>
  <div id="footer" class="col-12 px-0 row w-100 mx-0 ">
      <div class="col-12 col-lg-11 row mx-auto justify-content-between px-lg-0 py-4">
        <div class="col-12 col-lg-2 col-xl-1 px-0 text-center">
          <img :src="logo" alt="Онлайн казино VipMagnit" class="mw-100 mw-50 mx-auto mx-lg-0 mw-md-100">
        </div>
        <div class="col-12 col-lg-2 row mx-0 justify-content-between justify-content-lg-around px-0 px-lg-3">
          <div class="col-4 px-0 px-lg-2">
            <p class="footer-link-inner">
              <router-link :to="{name : 'home'}" class="footer-link">
                Казино
              </router-link>
            </p>
            <p class="footer-link-inner">
              <router-link
                      :to="{name: 'LaunchGame',
                            params: {
                              gameName:'WheelOfFortune',
                              gameId:1,
                              provider: 'WheelOfFortune'
                            }
                      }"
                      class="footer-link">
                Колесо
              </router-link>
            </p>
            <p class="footer-link-inner">
              <router-link :to="{name : 'deposit'}" class="footer-link">
                Депозит
              </router-link>
            </p>
          </div>
          <div class="col-6 px-0 px-lg-2">
            <p class="footer-link-inner">
              <router-link :to="{name : 'bonuses'}" class="footer-link">
                Бонусы
              </router-link>
            </p>
            <p class="footer-link-inner">
              <router-link :to="{name : 'terms'}" class="footer-link">
                Условия
              </router-link>
            </p>
          </div>
        </div>
        <div class="col-12 col-lg-4 px-0 px-lg-3">
          <div class="col-12 px-0 row mx-0 justify-content-start mb-3">
            <div v-for="(link, index) in socialLinks"
                 :key="index"
                 v-if="contacts[index]"
                 class="col-6 footer-contact-item row mx-0 justify-content-between pl-0 mb-2">
              <div class="col-3 footer-contact-icon-area p-0">
                <a :href="index == 'email' ? 'mailto:'+link : link" target="_blank" rel="noreferrer"
                   class="w-100 d-flex h-100 footer-contact-text text-white text-center"
                   v-lazy-container="{ selector: 'img',loading: loader}">
                  <img :src="contacts[index].icon" alt="VipMagnit Казино"
                       :data-src="contacts[index].icon"
                       class="mw-100 m-auto footer-social-icon">
                </a>
              </div>
              <div class="col-9 col-lg-9 footer-contact-info p-0 pl-2 pl-lg-0">
                <a :href="index == 'email' ? 'mailto:'+link : link" target="_blank" rel="noreferrer"
                   class="w-100 d-block footer-contact-text text-white">
                  {{ contacts[index].title }}
                </a>
              </div>
            </div>

            <div class="col-6 footer-contact-item row mx-0 justify-content-between pl-0 mb-2">
              <div class="col-3 footer-contact-icon-area p-0">
                <a href="mailto:vipmagnitvip@mail.ru" target="_blank" rel="noreferrer"
                   class="w-100 d-flex h-100 footer-contact-text text-white text-center"
                   v-lazy-container="{ selector: 'img',loading: loader}">
                  <img :src="contacts['complaints'].icon" alt="VipMagnit Казино"
                       :data-src="contacts['complaints'].icon"
                       class="mw-100 m-auto footer-social-icon">
                </a>
              </div>
              <div class="col-9 col-lg-9 footer-contact-info p-0 pl-2 pl-lg-0">
                <a href="mailto:vipmagnitvip@mail.ru" target="_blank" rel="noreferrer"
                   class="w-100 d-block footer-contact-text text-white">
                  {{ contacts['complaints'].title }}
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    <div class="footer-rights-area col-12">
      <h6 class="w-100 text-center rights-text  py-2 py-lg-3">
        © 2018-{{thisYear}} VipMagnit. Все права защищены.
      </h6>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      logo: require('@/../public/images/logos/vp-logo.png'),
      loader: require('@/../public/images/icons/main-loader.svg'),
      contacts: {
        email: {
          icon : require('@/../public/images/icons/social/mail.png'),
          title : 'Email',
        },
        tg_manager:{
          icon: require('@/../public/images/icons/social/tg.png'),
          title: "Телеграм менеджер",
        },
        tg_group: {
          icon: require('@/../public/images/icons/social/tg.png'),
          title: "Телеграм Канал",
        },
        tg_bot: {
          icon: require('@/../public/images/icons/social/tg.png'),
          title: "Телеграм Бот",
        },
        vk_manager: {
          icon: require('@/../public/images/icons/social/vk.png'),
          title: "Менеджер",
        },
        vk_group: {
          icon: require('@/../public/images/icons/social/vk.png'),
          title: "Вк Группа",
        },
        site_administration: {
          icon: require('@/../public/images/icons/social/tg.png'),
          title: "Администрация сайта",
        },
        complaints:{
          icon: require('@/../public/images/icons/social/mail.png'),
          title: "Жалобы",
        }
      }
    }
  },
  computed: {
    thisYear() {
      return new Date().getFullYear()
    },
    depositMethods () {
      const methods = this.$store.getters.getDepositMethods
      if (methods && methods.length && methods.length > 12) {
        return methods.slice(0, 12)
      }
      return methods
    },
    userData () {
      return this.$store.getters.userData
    },
    socialLinks() {
      return this.$store.getters.getSocialLinks
    },
  }
}
</script>

<style scoped>
  .footer-social-icon{
    height: 25px;
    object-fit: contain;
    width: 25px;
  }
  #footer{
    background-color: #0a0b0f;
  }
  .footer-link{
    color:#ffffff;
  }
  .footer-contact-item{
    height: 30px;
  }
  .footer-contact-text{
    line-height: 30px;
  }
  .footer-rights-area{
    background-color: #040406 !important;
  }
  .rights-text{
    color:#545454;
    font-size: 15px;
    user-select: none;
    user-modify: none;
    margin-bottom: 0;
  }
  @media (max-width:992px) {
  .mw-50{
    max-width: 50%!important;
  }
}
  @media (max-width:490px) {
    .footer-contact-item{
      height: 40px;
  }
}

</style>
